export default __webpack_public_path__ + "static/media/Rubik-Italic.20b4592e.woff2";